import { createIslandEntrypoint } from "~/lib/islands/create-island-entrypoint";
import SearchAutosuggestIsland from "~/islands/page/search-autosuggest/SearchAutosuggestIsland.svelte";

const ISLAND_NAME = "search-autosuggest";

/**
 * Reads whatever is already sitting in the pre-hydration skeleton's field — the SSR
 * `?q=` value on a `/search` landing, or a few characters a fast typist beat the mount
 * with — then wipes the skeleton. Aurora renders every affordance that replaces it (its
 * own trigger below 990px, its own field above), so the wipe is total on both paths —
 * see ADR 0004.
 *
 * ponytail: the unscoped querySelector assumes exactly one `input[name="q"]` in the
 * container — true today (mobile/desktop share one node, toggled by CSS). Scope it to a
 * specific element if the skeleton ever grows a second one.
 */
function beforeMount(container: HTMLElement): { initialQuery?: string } {
  const initialQuery = container.querySelector<HTMLInputElement>('input[name="q"]')?.value;
  container.innerHTML = "";
  return { initialQuery };
}

createIslandEntrypoint(SearchAutosuggestIsland, ISLAND_NAME, undefined, beforeMount);
